var TELEGRAM_ORIGIN_HOST = 't.me';
var TELEGRAM_ORIGIN_URL = "https://".concat(TELEGRAM_ORIGIN_HOST);
var INTERCOM_APP_ID = 'n0a1uomx';
var GOOGLE_TAG_MANAGER_ID = 'GTM-5D9TR4B';
var FEATURES = {};
export { TELEGRAM_ORIGIN_HOST, TELEGRAM_ORIGIN_URL, INTERCOM_APP_ID, GOOGLE_TAG_MANAGER_ID, FEATURES };